module.exports = __webpack_public_path__ + "static/media/icon_setting_white.fc61b702.svg";